/**
 * Reusable stateless form component for User by admins
 * 
 * TODO: Delete this, it's unused now that this all happens in Rome.
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import form components
import {
  EmailInput
  , ListComparator
  , PasswordInput
  , SimpleArrayEditor
  , TextInput
} from '../../../global/components/forms';

function AdminUserForm({
  user
  , formType
  , handleFormSubmit
  , handleFormChange
  , cancelLink
  , formTitle
  , ssoProviders
}) {

  // set the button text
  const buttonText = formType === "create" ? "Create User" : "Update User";

  // set the form header
  const header = formTitle ? <div className="formHeader"><h2> {formTitle} </h2><hr/></div> : <div/>;

  return (
    <div className="yt-container">
      <div className="yt-row center-horiz">
        <div className="form-container -slim">
          <form name="userForm" className="user-form" onSubmit={handleFormSubmit}>
            {header}
            <EmailInput
              name="username"
              label="Email Address"
              value={user.username}
              change={handleFormChange}
              placeholder="Email (required)"
              required={true}
              disabled={formType !== "create"}
            />
            { formType === "create" ?
              <PasswordInput
                name="password"
                label="Password"
                value={user.password}
                change={handleFormChange}
                required={true}
                password={true}
              />
              :
              null
            }
            <TextInput
              name="firstName"
              label="First Name"
              value={user.firstName}
              change={handleFormChange}
              required={true}
            />
            <TextInput
              name="lastName"
              label="Last Name"
              value={user.lastName}
              change={handleFormChange}
              required={true}
            />
            {/* <SimpleArrayEditor
              name="roles"
              label="User Roles"
              items={user.roles}
              arrayType="string"
              change={handleFormChange}
              helpText={<span>by default, either <strong>admin</strong> or <strong>null</strong></span>}
            /> */}
            <hr/>
            <hr/>
            {/* <SimpleArrayEditor
              name="ssoProviders"
              label="SSO Login Access"
              items={user.ssoProviders}
              arrayType="string"
              change={handleFormChange}
              helpText={<span>Don't change this unless you <strong>really</strong> know what you're doing. This field allows the user account to be authenticated by an external provider. It should be set automatically when a user in onboarded. Right now the only valid options are nothing, or 'acrp'</span>}
            /> */}
            <ListComparator
              name="ssoProviders"
              label="SSO Login Access"
              items={user.ssoProviders}
              allItems={ssoProviders}
              arrayType="string"
              change={handleFormChange}
              reorderable={false}
            />
            <span>Don't change this unless you <strong>really</strong> know what you're doing. This field allows the user account to be authenticated by an external provider. It should be set automatically when a user in onboarded. Right now the only valid options are nothing, or 'acrp'</span>
            <hr/>
            <div className="input-group">
              <div className="yt-row space-between">
                <Link className="yt-btn link" to={cancelLink}>Cancel</Link>
                <button className="yt-btn " type="submit" > {buttonText} </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

AdminUserForm.propTypes = {
  cancelLink: PropTypes.string.isRequired
  , formTitle: PropTypes.string
  , formType: PropTypes.string.isRequired
  , handleFormSubmit: PropTypes.func.isRequired
  , handleFormChange: PropTypes.func.isRequired
  , user: PropTypes.object.isRequired
  , ssoProviders: PropTypes.array.isRequired
}

AdminUserForm.defaultProps = {
  formTitle: ''
}

export default AdminUserForm;



// WEBPACK FOOTER //
// modules/user/components/AdminUserForm.js.jsx